module.exports = __webpack_public_path__ + "static/media/clear-bank.41cd3f4e.svg";